import React, { Component, Fragment } from "react";
import Details from "./Details";
import Validation from "./Validation";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import style from "./Precheck.module.scss";
import Authorization from "./Authorization";
import { Alert } from "reactstrap";
import { Mode, Type, ProductType, getOptionsTickerFromFields } from "../../../../utils/Order/Order";

class Precheck extends React.PureComponent {
  constructor(props) {
    super(props);

    const { validations } = props.precheck;

    this.state = {
      validations: validations,
      status: null,
      waitingCounter: validations ? 0 : null,
      loadingTotals: validations ? false : true,
      additionalProps: [],
    };
  }

  componentDidMount() {
    this._isMounted = true;

    if (this.state.loadingTotals == false) return;

    const { order, dispatch } = this.props;
    const { getRiskValidations, getTotalsAndEarnings } = this.props.actions;

    if (order.CurrentAccount.clientBankAccount && order.CurrentAccount.clientBankAccount !== "0") {
      order.cashdiffered = true;
    } else {
      order.cashdiffered = false;
    }

    getRiskValidations({ process: order.FundX ? "InOutFunds" : "Order" }).then((resp) => {
      this._isMounted &&
        this.setState({
          validations: resp.response.validations.reduce((obj, v) => {
            obj[v.ValidationProgram] = v;
            return obj;
          }, {}),
        });

      if (order.AssetClassForm == ProductType.OPTION) {
        order.AssetTicker = getOptionsTickerFromFields(order);
        //An Asset should be created in backend
        order.AssetId = "";
      }

      // Crear una copia del order para enviarlo al backend
      const orderToSend = { ...order };
      if (orderToSend.CurrentAccount) {
        orderToSend.CurrentAccount = { ...order.CurrentAccount };

        // Si CommissionType es "ClientPrice", hacer el swap de Commission con ClientPrice
        const commissionTypeStr = String(orderToSend.CurrentAccount.CommissionType || "").toLowerCase();
        if (commissionTypeStr.includes("clientprice") && orderToSend.CurrentAccount.ClientPrice) {
          orderToSend.CurrentAccount.Commission = orderToSend.CurrentAccount.ClientPrice;
        }
      }

      getTotalsAndEarnings({ order: orderToSend })
        .then((resp) => ({ order: resp.response.order, additionalProps: resp.response.additionalProps }))
        .then(({ order, additionalProps }) => {
          dispatch({
            type: "UPDATE_PRECHECK",
            fields: { order },
          });
          if (this._isMounted) {
            this.setState({ loadingTotals: false, additionalProps });
            this.validateRules();
          }
        });
    });
  }

  componentWillUpdate(nextProps) {
    const { AccountId } = nextProps.order.CurrentAccount;

    if (this.props.order.CurrentAccount.AccountId != AccountId) {
      this.setState(
        {
          validations: null,
          status: null,
          loadingTotals: true,
        },
        () => {
          this.componentDidMount();
        }
      );
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  validateRules = () => {
    const { validations } = this.state;

    this.setState({ waitingCounter: Object.keys(validations).length });

    Object.values(validations).forEach((validation) => {
      const service = validation.ValidationProgram;
      const { actions, order } = this.props;

      actions.validateRule({ service, order, validation }).then((resp) => {
        const { result } = resp.response.validation;
        const { history } = resp.response;

        let status = "success";
        let title;

        if (result.Code !== 200) {
          if (validation.OverrridableByAuthorization !== "0") {
            title = result.Description != "" ? result.Description : null;
            this.checkIfCanBeAuthorized(validation, title);
            return;
          } else if (result.Code === 207) {
            status = "warningmessage";
            title = result.Description != "" ? result.Description : null;
          } else {
            status = "failed";
            title = result.Description != "" ? result.Description : null;
          }
        }

        this.updateValidationStatus(
          {
            ...validation,
            history,
          },
          status,
          title
        );
      });
    });
  };

  updateValidationStatus = (validation, vStatus, title) => {
    const { validations, waitingCounter, status } = this.state;
    const { dispatch } = this.props;

    let globalStatus = status == "failed" ? status : vStatus;

    // Si fue la ultima validacion y no fallo
    if (globalStatus != "failed" && waitingCounter == 1) {
      globalStatus = "completed";
    }

    const _validations = {
      ...validations,
      [validation.ValidationProgram]: {
        ...validations[validation.ValidationProgram],
        status: vStatus,
        history: validation.history,
        title,
      },
    };

    if (waitingCounter == 1) {
      dispatch({
        type: "UPDATE_PRECHECK",
        fields: {
          histories: Object.values(_validations)
            .filter((v) => v.history != undefined)
            .map((v) => v.history),

          validations: _validations,
          status: globalStatus,
        },
      });

      dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
    }
    this._isMounted &&
      this.setState({
        validations: _validations,
        status: globalStatus,
        waitingCounter: waitingCounter - 1,
      });
  };

  checkIfCanBeAuthorized = (validation, title) => {
    const { actions, dispatch, order } = this.props;
    const { checkAuth } = actions;

    const definitionId = validation.OverrridableByAuthorization;

    checkAuth({ definitionId, order }).then((resp) => {
      const authorization = resp.response.authorizationsdt;
      const { precheck } = this.props;

      let status;

      if (authorization.canbeauthorized) {
        // basket order no allow authorizations
        if (
          validation.AuthorizationDefinitionRole.toLowerCase() != "self" &&
          order.OrderHierarchy != Type.Default
        ) {
          status = "failed";
        } else {
          status = "authorization";

          dispatch({
            type: "UPDATE_PRECHECK",
            fields: {
              authorizations: [
                ...precheck.authorizations,
                { ...authorization, name: validation.ValidationName, description: title },
              ],
            },
          });
        }
      } else {
        status = "failed";
      }

      this.updateValidationStatus(validation, status, title);
    });
  };

  updateAuthorizationMessage = (name, text) => {
    const { dispatch, precheck } = this.props;

    const authorizations = precheck.authorizations.map((a) => {
      if (a.name === name) {
        return {
          ...a,
          text,
          error: undefined,
          readonly: undefined,
        };
      }
      return a;
    });

    dispatch({
      type: "UPDATE_PRECHECK",
      fields: {
        authorizations,
      },
    });
  };

  render() {
    const { order, precheck } = this.props;
    const { validations, status, waitingCounter, loadingTotals, additionalProps } = this.state;

    return (
      <div className={style.precheck}>
        {order.OrderHasMultipleAccounts && <AccountDetail {...order.CurrentAccount} />}
        {loadingTotals ? (
          <LoadingMessage text={"Retrieving totals and earnings"} />
        ) : (
          <Details
            precheck={precheck}
            form={order.AssetClassForm}
            result={order.CurrentAccount.Precheck}
            additionalProps={additionalProps}
          />
        )}

        {validations == null ? (
          <LoadingMessage text={"Retrieving risk validations"} />
        ) : (
          <div className={style.validations}>
            <p className="h6">Validations</p>
            {Object.values(validations).map((v, index) => (
              <Validation validation={v} key={`val-${index}`} />
            ))}
          </div>
        )}

        {status != null ? (
          status == "failed" ? (
            <NoPassConditions hierarchy={order.OrderHierarchy} />
          ) : (
            precheck.authorizations.length > 0 &&
            waitingCounter == 0 && (
              <Fragment>
                <p className="h6">Authorizations</p>
                <div className={style.authorizations}>
                  {precheck.authorizations.map((a, index) => (
                    <Authorization
                      authorization={a}
                      changeMessage={this.updateAuthorizationMessage}
                      key={`auth-${index}`}
                    />
                  ))}
                </div>
              </Fragment>
            )
          )
        ) : null}
      </div>
    );
  }
}

const AccountDetail = ({ AccountName, AccountNumber }) => {
  return (
    <div className={style.account}>
      <span>Prechecking account</span>
      <span>
        {AccountNumber}
        {" - "}
        {AccountName}
      </span>
    </div>
  );
};

const NoPassConditions = ({ hierarchy }) => (
  <Fragment>
    <hr />
    <Alert color="danger" className={style.alert}>
      {hierarchy !== Type.Default
        ? `Order declined by system. (${hierarchy} order not allow authorizations)`
        : "Order declined by system."}
    </Alert>
  </Fragment>
);

export const LoadingMessage = ({ text, ...props }) => (
  <div className={style.loadingMessage} style={props.style || {}}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export default Precheck;
